import { baseUrl } from 'volto-ebc-radionacional/utils/api';
import { normalizeImageUrl } from 'volto-ebc-radionacional/utils/normalizeImageUrl';

export type ProgramLatestEpisodeItem = {
  '@id': string;
  title: string;
  image?: string;
  audio?: string;
  dateAiring?: string;
  datePublished?: string;
  parentTitle?: string;
};

type GetContentLatestFromProgramParams = {
  programPath: string;
  page?: number;
  parentTitle?: string;
};

type GetContentLatestFromProgramResult = {
  items: ProgramLatestEpisodeItem[];
  page: number;
  hasMore: boolean;
};

function normalizeProgramPath(programPath: string) {
  const raw = String(programPath || '').trim();

  if (!raw) return '';

  const withoutDomain = raw.replace(/^https?:\/\/[^/]+/i, '');
  const withoutApiPrefix = withoutDomain.replace(/^\/\+\+api\+\+/i, '');

  return withoutApiPrefix.startsWith('/')
    ? withoutApiPrefix
    : `/${withoutApiPrefix}`;
}

export function normalizeProgramEpisodes(
  data: unknown,
  parentTitle = '',
): ProgramLatestEpisodeItem[] {
  const rawItems = Array.isArray(data) ? data : [];

  return rawItems.map((item: any) => {
    const baseId = item?.['@id'] ?? '';

    return {
      '@id': baseId,
      title: item?.title ?? '',
      image: normalizeImageUrl(item?.image ?? '', baseId),
      audio: item?.audio ?? '',
      dateAiring: item?.dateAiring ?? '',
      datePublished: item?.datePublished ?? '',
      parentTitle: item?.programTitle ?? item?.parentTitle ?? parentTitle ?? '',
    };
  });
}

export async function getContentLatestFromProgram({
  programPath,
  page = 1,
  parentTitle = '',
}: GetContentLatestFromProgramParams): Promise<GetContentLatestFromProgramResult> {
  const safePage = Math.max(page, 1);
  const apiPage = safePage - 1;

  try {
    const normalizedPath = normalizeProgramPath(programPath);

    const url = `${baseUrl}${normalizedPath}/@content-latest-from-program?page=${apiPage}`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(
        `Erro ao buscar conteúdos do programa: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    const items = normalizeProgramEpisodes(data, parentTitle);

    return {
      items,
      page: safePage,
      hasMore: items.length > 0,
    };
  } catch (error) {
    console.error(
      'Falha ao buscar conteúdos mais recentes do programa:',
      error,
    );

    return {
      items: [],
      page: safePage,
      hasMore: false,
    };
  }
}
